import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

const TOS_URL = paths.website.terms;
// The privacy policy doubles as the DPDPA notice (purpose, retention, rights).
const PRIVACY_URL = paths.website.privacy;

/**
 * Consent shown as fine print above the submit button: submitting the form is
 * the act of accepting the Terms, the Privacy Policy and DPDPA processing.
 *
 * The consent records themselves are written server-side inside POST /auth/me
 * (captureSignupConsents). Do NOT capture them again from the client - the
 * server call is idempotent and every duplicate comes back 409, which the API
 * logs as a failed request with a stack trace.
 *
 * NOTE for whoever revisits this: DPDPA s.6(1) wants consent that is "free,
 * specific, informed, unconditional and unambiguous, with a clear affirmative
 * action", which consent-by-conduct does not obviously satisfy. This shape was
 * a deliberate product call for onboarding friction. Restoring tick-boxes is a
 * local change here plus a gate on the submit button.
 *
 * There is no WhatsApp opt-in: dealers are businesses and the messages we send
 * them are transactional, so there is no marketing consent to collect.
 */
export function ConsentFinePrint() {
  const { t } = useTranslate('arthamShared');

  return (
    <Typography variant="caption" color="text.disabled" sx={{ lineHeight: 1.5 }}>
      {t('consent.byConductPrefix')}{' '}
      <Link href={TOS_URL} target="_blank" rel="noopener" color="inherit" underline="always">
        {t('consent.termsOfService')}
      </Link>
      {t('consent.byConductMiddle')}{' '}
      <Link href={PRIVACY_URL} target="_blank" rel="noopener" color="inherit" underline="always">
        {t('consent.privacyPolicy')}
      </Link>
      {t('consent.byConductSuffix')}
    </Typography>
  );
}
